import { render, staticRenderFns } from "./Sessions.vue?vue&type=template&id=1888130c&scoped=true"
import script from "./Sessions.vue?vue&type=script&lang=ts"
export * from "./Sessions.vue?vue&type=script&lang=ts"
import style0 from "./Sessions.vue?vue&type=style&index=0&id=1888130c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1888130c",
  null
  
)

export default component.exports